import * as r from 'ramda';
import { createSelector } from 'reselect';

const mapInfluencerRecord = ({
  Id: id,
  PublisherId: publisherID,
  Key: key,
  DatasetName: datasetName,
  Data: data,
}) => ({
  id,
  publisherID,
  key,
  datasetName,
  data,
});

const getInfluencersBase = r.prop('influencers');

const getInfluencersList = r.pipe(getInfluencersBase, r.prop('list'));

export const getInfluencers = createSelector(
  getInfluencersList,
  ({
    Records: records,
    PageSize: pageSize,
    PageNumber: pageNumber,
    TotalCount: totalCount,
    TotalPages: totalPages,
  }) => ({
    pageSize: parseInt(pageSize),
    pageNumber: parseInt(pageNumber),
    totalCount,
    totalPages,
    records: r.map(mapInfluencerRecord, records),
  })
);
